// Static content for Urban Painter — Epoxy Flooring · Waterproofing · Painting

export const HERO_SLIDES = [
  {
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/f8ktji6j_Screenshot%202026-08-16%20092114.png",
    eyebrow: "Since 2019 · Gurugram · Pan India Epoxy",
    kicker: "Epoxy Flooring · Waterproofing · Painting",
  },
  {
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/707tihzb_Screenshot%202026-08-16%20092022.webp",
    eyebrow: "Residential · Commercial · Industrial",
    kicker: "Professional site inspection. Suitable materials.",
  },
  {
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/fr4j9kcj_Screenshot%202026-08-16%20092055.png",
    eyebrow: "8 cities · Pan India Epoxy Coverage",
    kicker: "Quality workmanship, transparent quotations.",
  },
];

export const CORE_SERVICES = [
  {
    n: "01",
    slug: "epoxy-flooring",
    title: "Epoxy Flooring",
    lead: "Seamless, durable and professional flooring solutions.",
    desc: "For garages, factories, warehouses, workshops, showrooms and commercial spaces.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/fr4j9kcj_Screenshot%202026-08-16%20092055.png",
    href: "/epoxy-flooring",
    cta: "Explore Epoxy Flooring",
    badge: "Pan India Service",
  },
  {
    n: "02",
    slug: "waterproofing",
    title: "Waterproofing",
    lead: "Professional waterproofing and leakage protection.",
    desc: "For roofs, terraces, bathrooms, basements, walls, balconies and water tanks.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/wkrh8l47_Screenshot%202025-01-29%20071934.png",
    href: "/waterproofing",
    cta: "Explore Waterproofing",
    badge: "Gurugram · Delhi NCR",
  },
  {
    n: "03",
    slug: "painting",
    title: "Painting Services",
    lead: "Professional interior and exterior painting.",
    desc: "For homes, offices, commercial buildings and industrial properties.",
    image:
      "https://images.pexels.com/photos/6474504/pexels-photo-6474504.jpeg?auto=compress&cs=tinysrgb&w=1400",
    href: "/painting",
    cta: "Explore Painting Services",
    badge: "Gurugram · Delhi NCR",
  },
];

export const EPOXY_TYPES = [
  "Garage Epoxy Flooring",
  "Industrial Epoxy Flooring",
  "Commercial Epoxy Flooring",
  "Warehouse Flooring",
  "Factory Flooring",
  "Workshop Flooring",
  "Showroom Flooring",
  "Parking Flooring",
  "Residential Epoxy Flooring",
  "Decorative Epoxy Flooring",
  "Self-Leveling Epoxy",
  "Anti-Slip Epoxy",
  "Heavy-Duty Epoxy",
  "Epoxy Floor Coating",
];

export const WATERPROOFING_TYPES = [
  {
    name: "Roof & Terrace Waterproofing",
    note: "Protection against rainwater penetration, cracks and leakage.",
  },
  {
    name: "Bathroom Waterproofing",
    note: "Waterproofing for bathrooms, wet areas and floors to help prevent seepage.",
  },
  {
    name: "Basement Waterproofing",
    note: "Solutions for dampness, seepage and water penetration.",
  },
  {
    name: "Exterior Wall Waterproofing",
    note: "Protection against rainwater and moisture penetration.",
  },
  {
    name: "Balcony Waterproofing",
    note: "Treatment for leakage and seepage from balconies and floor joints.",
  },
  {
    name: "Water Tank Waterproofing",
    note: "Waterproofing solutions for suitable overhead and underground tanks.",
  },
  {
    name: "Leakage & Seepage Treatment",
    note: "Inspection and treatment of visible leakage, dampness and seepage problems.",
  },
  {
    name: "New Construction Waterproofing",
    note: "Waterproofing solutions for appropriate stages of new construction.",
  },
];

export const PAINTING_TYPES = [
  {
    name: "Interior Painting",
    note: "Premium wall and ceiling painting for homes, apartments, offices and commercial interiors.",
  },
  {
    name: "Exterior Painting",
    note: "Weather-resistant exterior painting solutions for buildings and properties.",
  },
  {
    name: "Residential Painting",
    note: "Complete painting solutions for houses, villas and apartments.",
  },
  {
    name: "Commercial Painting",
    note: "Painting services for offices, shops, showrooms and commercial buildings.",
  },
  {
    name: "Industrial Painting",
    note: "Suitable painting solutions for industrial and utility spaces.",
  },
  {
    name: "Wall Preparation",
    note: "Surface cleaning, crack repair, putty, primer and preparation before final paint application.",
  },
  {
    name: "Texture Painting",
    note: "Decorative texture finishes for selected interior and exterior surfaces.",
  },
  {
    name: "Wood & Metal Painting",
    note: "Professional painting and finishing solutions for suitable wood and metal surfaces.",
  },
];

export const WHY_US = [
  "Established in 2019",
  "Professional site inspection",
  "Proper surface preparation",
  "Suitable material selection",
  "Skilled workmanship",
  "Quality-focused application",
  "Residential & commercial projects",
  "Transparent quotations",
  "Professional project execution",
  "Clean and organized workmanship",
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Site Inspection",
    desc: "Understand the property, surface condition and customer requirement.",
  },
  {
    n: "02",
    title: "Problem Assessment",
    desc: "Identify leakage, seepage, damaged surfaces, flooring condition or painting requirements.",
  },
  {
    n: "03",
    title: "Preparation",
    desc: "Clean, repair, grind, scrape, fill, prime or otherwise prepare the surface as required.",
  },
  {
    n: "04",
    title: "Material & System Selection",
    desc: "Select an appropriate flooring, waterproofing or painting system based on actual site conditions.",
  },
  {
    n: "05",
    title: "Professional Application",
    desc: "Carry out the required work using appropriate tools and application methods.",
  },
  {
    n: "06",
    title: "Finishing",
    desc: "Complete the required coats, finish, texture or protective system.",
  },
  {
    n: "07",
    title: "Final Inspection",
    desc: "Inspect the completed work and provide appropriate maintenance guidance.",
  },
];

export const COMMON_PROBLEMS = [
  "Roof Leakage",
  "Terrace Leakage",
  "Wall Dampness",
  "Bathroom Seepage",
  "Basement Moisture",
  "Cracked Walls",
  "Peeling Paint",
  "Faded Exterior Paint",
  "Dusty Concrete Floors",
  "Cracked Flooring",
  "Oil-Stained Floors",
  "Worn-Out Surfaces",
];

export const COMPLETE_SOLUTIONS = [
  {
    name: "New Construction",
    combo: "Painting + Waterproofing + Flooring",
  },
  {
    name: "Home Renovation",
    combo: "Interior Painting + Waterproofing + Epoxy Flooring",
  },
  {
    name: "Commercial Property",
    combo: "Exterior Painting + Waterproofing + Commercial Flooring",
  },
  {
    name: "Industrial Property",
    combo: "Industrial Painting + Waterproofing + Epoxy Flooring",
  },
];

// Project categories — using unbranded contextual images (labelled as illustrative)
export const PROJECT_CATEGORIES = [
  { key: "all", label: "All" },
  { key: "epoxy", label: "Epoxy Flooring" },
  { key: "waterproofing", label: "Waterproofing" },
  { key: "painting", label: "Painting" },
];

export const PROJECTS = [
  {
    id: "p01",
    cat: "epoxy",
    sub: "Industrial Factory",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/f8ktji6j_Screenshot%202026-08-16%20092114.png",
  },
  {
    id: "p02",
    cat: "epoxy",
    sub: "Warehouse",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/707tihzb_Screenshot%202026-08-16%20092022.webp",
  },
  {
    id: "p03",
    cat: "epoxy",
    sub: "Production Floor",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/fr4j9kcj_Screenshot%202026-08-16%20092055.png",
  },
  {
    id: "p04",
    cat: "epoxy",
    sub: "Clean Room",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/6qxhii8k_Screenshot%202026-08-16%20092045.webp",
  },
  {
    id: "p05",
    cat: "epoxy",
    sub: "Pharma / Lab",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/ze3ayc0w_Screenshot%202026-08-16%20092036.webp",
  },
  {
    id: "p06",
    cat: "epoxy",
    sub: "Commercial",
    image:
      "https://images.pexels.com/photos/1329711/pexels-photo-1329711.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    id: "p07",
    cat: "waterproofing",
    sub: "Roof",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/cczbf2mq_Screenshot%202025-01-29%20071914.png",
  },
  {
    id: "p08",
    cat: "waterproofing",
    sub: "Terrace",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/wkrh8l47_Screenshot%202025-01-29%20071934.png",
  },
  {
    id: "p09",
    cat: "waterproofing",
    sub: "Balcony",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/fy48sugg_Screenshot%202025-01-29%20071927.png",
  },
  {
    id: "p10",
    cat: "waterproofing",
    sub: "Bathroom",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/a4qtslov_2021-12-07T02_36_43.webp",
  },
  {
    id: "p11",
    cat: "waterproofing",
    sub: "Basement",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/q5e21leg_210120-Nano-G-PU-Injection-Article-Featured-img-2.webp",
  },
  {
    id: "p12",
    cat: "waterproofing",
    sub: "Wall",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/x4jhbend_exterior-wall-waterproofing-service.png",
  },
  {
    id: "p12b",
    cat: "waterproofing",
    sub: "Metal Roof",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/2q4r079g_WhatsApp%20Image%202023-07-22%20at%207.17_edited.jpg",
  },
  {
    id: "p13",
    cat: "painting",
    sub: "Interior",
    image:
      "https://images.pexels.com/photos/6474504/pexels-photo-6474504.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    id: "p14",
    cat: "painting",
    sub: "Exterior",
    image:
      "https://images.pexels.com/photos/280221/pexels-photo-280221.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    id: "p15",
    cat: "painting",
    sub: "Residential",
    image:
      "https://images.pexels.com/photos/6474471/pexels-photo-6474471.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    id: "p16",
    cat: "painting",
    sub: "Commercial",
    image:
      "https://images.pexels.com/photos/1743227/pexels-photo-1743227.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    id: "p17",
    cat: "painting",
    sub: "Industrial",
    image:
      "https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
  {
    id: "p18",
    cat: "painting",
    sub: "Interior",
    image:
      "https://images.pexels.com/photos/8961344/pexels-photo-8961344.jpeg?auto=compress&cs=tinysrgb&w=1400",
  },
];

export const FAQS = [
  {
    q: "What services does Urban Painter provide?",
    a: "Urban Painter provides three core services: Epoxy Flooring, Waterproofing and Painting. Our epoxy flooring service is available Pan India — with active project delivery in Bangalore, Hyderabad, Kolkata, Pune, Chennai, Baddi, Ahmedabad and Gurgaon. Our waterproofing and painting services are focused on Gurugram, Manesar, Sohna and Delhi NCR. We work across residential apartments, independent houses, offices, showrooms, warehouses, factories and industrial units.",
  },
  {
    q: "Which epoxy flooring systems do you offer?",
    a: "We install self-leveling epoxy, heavy-duty epoxy, anti-slip epoxy, PU-modified epoxy, decorative epoxy, epoxy floor coating, ESD flooring and food-grade epoxy — for garages, factories, warehouses, workshops, showrooms, parking areas, clean rooms and pharma facilities. The correct system depends on substrate condition, expected traffic, chemical exposure, moisture level and required finish.",
  },
  {
    q: "Do you provide waterproofing for existing buildings?",
    a: "Yes. Waterproofing on an existing building is possible, subject to a site inspection and honest assessment of the actual condition, source of leakage or seepage, and structural context. We treat roofs, terraces, bathrooms, basements, walls, balconies, water tanks and areas of visible dampness. We identify the source before recommending a treatment — the visible symptom is not always where the water is entering.",
  },
  {
    q: "Can epoxy flooring be applied over existing concrete?",
    a: "It depends entirely on the substrate. The existing concrete surface must be inspected for moisture content, cracks, contamination from oil or previous coatings, curing age and mechanical strength. Surface preparation — mechanical grinding or shot blasting, crack repair and priming — is a critical part of the epoxy scope. Skipping preparation is the single largest cause of epoxy failure. A proper site inspection is always the first step.",
  },
  {
    q: "How much does painting cost in Gurgaon?",
    a: "Painting cost depends on the area to be painted, current surface condition, level of preparation required (cleaning, crack repair, putty, primer), the paint system selected (economy, premium emulsion, weather-shield exterior, texture, PU) and the desired finish. Interior painting typically costs less than exterior weather-shield systems. We provide itemised quotations after understanding the scope so you know exactly what is included.",
  },
  {
    q: "How long does waterproofing take?",
    a: "Timelines depend on the area, current condition, waterproofing system selected and scope of work. A single bathroom treatment may take 3–5 days including surface preparation, chemical application and curing. A full terrace treatment usually takes 5–10 days. Basement or exterior wall waterproofing on a larger building may take 2–3 weeks. Weather and curing time cannot be rushed.",
  },
  {
    q: "Do you provide interior and exterior painting?",
    a: "Yes. Urban Painter provides both interior and exterior painting for residential, commercial and industrial properties. Interior scopes include wall preparation, primer, base coats and finish coats in premium emulsions or texture systems. Exterior scopes use weather-shield emulsions or elastomeric coatings designed for the Gurgaon and NCR climate.",
  },
  {
    q: "Is surface preparation included in the quotation?",
    a: "Yes. Appropriate surface preparation is treated as a real part of the job — not an afterthought. Cracks are filled, dampness is treated at the source before repainting, contaminants are removed, primer is applied where required. The scope of preparation is called out clearly in the quotation so nothing is hidden.",
  },
  {
    q: "Do you provide quotations before starting work?",
    a: "Always. Quotations are prepared after understanding the project requirements and, where necessary, inspecting the site. Where we cannot see the actual condition (for example a leakage originating from an unknown source), we recommend a site inspection first and then quote against the actual scope, not an assumed one.",
  },
  {
    q: "Which cities do you serve?",
    a: "Our full-service coverage (all three services) is available across Gurugram, Gurgaon, Manesar, Sohna, New Gurgaon, Golf Course Road, DLF areas, South Delhi and the wider Delhi NCR. Epoxy flooring is available Pan India — including Bangalore, Hyderabad, Kolkata, Pune, Chennai, Baddi and Ahmedabad — for industrial, warehouse, factory and commercial projects.",
  },
  {
    q: "What warranty do you provide?",
    a: "Warranty terms depend on the product used and the system installed. Epoxy floors typically carry a workmanship warranty on the applied system. Waterproofing carries a warranty against leakage for the treated area subject to normal usage. Painting carries the manufacturer's product warranty. The warranty terms are stated on the quotation for each project.",
  },
  {
    q: "Are your materials genuine?",
    a: "Yes. We use materials from established manufacturers — Asian Paints, Berger, Fosroc, Sika, Dr. Fixit, Pidilite, MC-Bauchemie, STP and similar tier-1 brands. Material invoices can be shared on request. Genuine material is a non-negotiable — it directly determines how long the finish lasts.",
  },
  {
    q: "Can I combine multiple services on one project?",
    a: "Yes, and it usually helps. On a new construction or renovation, combining exterior painting + waterproofing + flooring under one team keeps the sequencing correct and prevents downstream rework. A newly painted wall is only as durable as the waterproofing behind it; a beautiful floor is only as clean as the trades finishing above it.",
  },
];

export const PROPERTY_TYPES = [
  "Independent House / Villa",
  "Apartment / Flat",
  "Office",
  "Shop / Showroom",
  "Warehouse",
  "Factory",
  "Industrial Unit",
  "Under Construction",
  "Other",
];

export const SERVICE_OPTIONS = [
  "Epoxy Flooring",
  "Waterproofing",
  "Painting",
  "Multiple Services",
];
